<template>
  <div class="bgFrame">
    <div
      :class="boxClass"
      style="z-index: 499; display: flex; justify-content: center"
    >
      <img src="../../assets/tab2_banner3.png" class="bgImg" />
    </div>
    <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
    </div>
    <div
      class="box"
      style="z-index: 501; display: flex; justify-content: center"
    >
      <div class="textFrame">
        <div style="width: 100%; margin-top: 184px"></div>
        <div style="display: flex; justify-content: center">
          <div :class="titleClass">品質擔當，安全可靠</div>
        </div>
        <div style="width: 100%; margin-top: 10px;"></div>
        <div style="display: flex; justify-content: center">
          <div :class="contentClass">
            選用的中央廚房符合ISO22000標準和HACCP体系認証<br />深入源頭把控，甄選優質食材，有效保障食材安全同食物品質
          </div>
        </div>
        <div class="largeImg">
            <icon v-for="(item, index) in showList" :data="item" :start="startIcon" :key="index"></icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted } from "vue";
import Icon from "./icon.vue";

export default {
  name: "App",
  components: {
      Icon
  },
  setup() {
    onMounted(() => {});

    const showList = ref([
        {index : 0,name: '控卡', img: require('../../assets/icon_kcal.png')},
        {index : 1,name: '控糖', img: require('../../assets/icon_sugar.png')},
        {index : 2,name: '控鹽', img: require('../../assets/icon_salt.png')},
        {index : 3,name: '控油', img: require('../../assets/icon_oil.png')},
    ])

    let titleClass = ref('start_textSubFrame')
    let contentClass = ref('start_textContent')
    let boxClass = ref('box_normal')

    const startAnime = ref(false)
    const startIcon = ref(false);
    const changeAnime = () =>{
      titleClass.value = 'start_textSubFrame'
      contentClass.value = 'start_textContent'
      boxClass.value = 'box_normal'
      startIcon.value = false
      if (startAnime.value == false) {
        setTimeout(() => {
          boxClass.value = 'box_anime'
          titleClass.value = 'textSubFrame'
          startIcon.value = true
          setTimeout(() => {
            contentClass.value = 'textContent'
          }, 400);
        }, 800);
      }
    }

    let pointImg = ref(require('../../assets/noise.png'))
    return {
      pointImg,
      titleClass,
      contentClass,
      changeAnime,
      startAnime,
      showList,
      startIcon,
      boxClass
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes boxAnime {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
.box_anime{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 1;
  animation-duration: 2s;
  animation-name: boxAnime;
}
.box_normal{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 0;
}
.bgFrame {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: white;
}
.box{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.bgImg{
  height: 100%;
  min-height: 878px;
  position: absolute;
  top: 0;
  object-fit: cover;
}
.textFrame {
  height: 100%;
  width: 1100px;
  display: flex;
  flex-direction: column;
  align-content: center;
}

@keyframes textSubAnime {
    from  {
      transform: translate(0px, 20px);
      opacity: 0;
      }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.textSubFrame{
    font-size: 65px;
    font-family: MicrosoftYaHeiLight;
    color: #685647;
    line-height: 50px;
    opacity: 1;
    animation-name: textSubAnime;
    animation-duration: 0.7s;
    animation-timing-function:ease-in-out;
}

.start_textSubFrame{
    font-size: 65px;
    font-family: MicrosoftYaHeiLight;
    color: #685647;
    line-height: 50px;
    opacity: 0;
}

@keyframes textContentAnime {
  from   {
      transform: translate(0px, 20px);
      opacity: 0;
      }
   to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.textContent{
    font-size: 18px;
    font-family: MicrosoftYaHeiLight;
    color: #685647;
    opacity: 1;
    animation-name: textContentAnime;
    animation-duration: 1s;
    animation-timing-function:ease-in-out;
    line-height: 29px;
}
.start_textContent{
    font-size: 18px;
    font-family: MicrosoftYaHeiLight;
    color: #685647;
    opacity: 0;
    line-height: 29px;
}

.largeImg {
  width: 100%;
  aspect-ratio: 527 / 113;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position:50%;
  animation :pointAnime 1s steps(2) infinite;
}

</style>
